import React, {Fragment} from 'react';
import {translate} from "../Services/translation";

const FacetedSearchCompact = ({
                                  facetFilters,
                                  visibleDropdownMenu,
                                  toggleVisibleDropdownMenu,
                                  onFacetChange,
                                  onSubmit
                              }) => (

    <ul className="faceted-search faceted-search--compact">
        {facetFilters && facetFilters.map((group, groupIndex, array) => group.options && group.options.length > 0 && (
            <div className="faceted-search__group" key={groupIndex}>
                <div>
                    <a className="faceted-search__accordion-button" href={'#group' + groupIndex} aria-controls={'#group' + groupIndex} data-bs-target={'#group' + groupIndex}
                            data-bs-toggle="collapse">
                        <h5 className="faceted-search__group-header mb-0  d-flex justify-content-between align-items-center">
                            {group.label}
                            <img src="/UI/images/dropdown-arrow.svg" className="faceted-search__accordion-button-icon"/>
                        </h5>
                    </a>
                    <ul className="faceted-search__sublist p-0 collapse" id={"group" + groupIndex}>
                        {group.options && group.options.map((item, itemIndex, array) =>
                            (
                                <li key={`${item.label}-${itemIndex}`} className="faceted-search__item"
                                    role="faceted-search-item">
                                    <FacetedFilterCheckbox item={item} group={group} onFacetChange={onFacetChange}/>
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        ))}
        <div className="faceted-search__item d-flex">
            <button className="me-1 p-3 btn btn-primary text-white my-2 w-50" onClick={event => {
                onSubmit(facetFilters);
            }}>{translate('general.filter')}</button>
            
            <button className="ms-1 p-3 btn btn-dark text-white my-2 w-50"
                    onClick={event => {
                        let filters = facetFilters.map(filter => {
                            return {
                                ...filter,
                                selectedOptions: []
                            }
                        });

                        onSubmit(filters);
                    }}
            >{translate('general.clearfilter')}</button>
        </div>
    </ul>
)

const FacetedFilterCheckbox = ({item, group, onFacetChange}) => (
    <label className="faceted-filter">
        <input className="faceted-filter__input" type="checkbox" onChange={event => onFacetChange(group, item)}
               checked={group.selectedOptions.includes(item.id)}/>
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && item.quantity > 0 &&
            <span className="faceted-filter__quantity"> ({item.quantity})</span>
            }
        </span>
    </label>
)

export default FacetedSearchCompact;
